module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "text-secondary",
    attrs: {
      "to": _vm.familyuser ? '/family/' + (typeof _vm.familyuser.family === 'object' ? _vm.familyuser.family : _vm.familyuser.family.id) : '#'
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "alt": "",
      "src": _vm.image || (_vm.familyuser ? _vm.familyuser.avatar : undefined) || '/network/static/img/default.jpg',
      "title": _vm.familyuser && _vm.familyuser.name
    }
  }), _vm._v(" "), (_vm.showName) ? _c('span', [_vm._v(_vm._s(_vm.familyuser && _vm.familyuser.name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2ea9356!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/c-uavatar.vue
// module id = 672
// module chunks = 1